var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgActionSmallPlusDisabled = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "action/small/plus/disabled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ChatBot",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_close_48px",
    transform: "translate(15, 15.0717) rotate(45) translate(-15, -15.0717)translate(5, 5.0717)",
    fill: "#BFBFBF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5550017,0.444998252 C18.9616707,-0.148332751 17.9996911,-0.148332751 17.4063601,0.444998252 L10,7.85135837 L2.59363988,0.444998252 C2.00030888,-0.148332751 1.03832926,-0.148332751 0.444998252,0.444998252 C-0.148332751,1.03832926 -0.148332751,2.00030888 0.444998252,2.59363988 L7.85135837,10 L0.444998252,17.4063601 C-0.148332751,17.9996911 -0.148332751,18.9616707 0.444998252,19.5550017 C1.03832926,20.1483328 2.00030888,20.1483328 2.59363988,19.5550017 L10,12.1486416 L17.4063601,19.5550017 C17.9996911,20.1483328 18.9616707,20.1483328 19.5550017,19.5550017 C20.1483328,18.9616707 20.1483328,17.9996911 19.5550017,17.4063601 L12.1486416,10 L19.5550017,2.59363988 C20.1483328,2.00030888 20.1483328,1.03832926 19.5550017,0.444998252 Z",
    id: "Path"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActionSmallPlusDisabled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/action-small-plus-disabled.1f47453cc9405c5997626111121e8206.svg";